import { Tooltip } from '@mui/material';
import { ReactComponent as VIcon } from '@elementary/common-ui/assets/v-green.svg';
import { ReactComponent as InfoIcon } from '@elementary/common-ui/assets/alert-info.svg';
import { StatusChip, SvgIcon } from '@elementary/common-ui/components';
import { ScimConfigStatus } from '../types';

const ProvisioningStatusChip = ({ status }: { status: ScimConfigStatus }) => {
  const chipStatus = status === ScimConfigStatus.ACTIVE ? 'active' : 'pending';
  const icon =
    status === ScimConfigStatus.ACTIVE ? (
      <VIcon width={14} />
    ) : (
      <SvgIcon width={16} fillColor="gray2" strokeColor="gray2" strokeWidth={1}>
        <InfoIcon />
      </SvgIcon>
    );
  const tooltip =
    status === ScimConfigStatus.ACTIVE
      ? null
      : 'No syncs have occurred yet. The configuration will become active once the first sync completes.';

  if (tooltip) {
    return (
      <Tooltip title={tooltip} arrow>
        <span>
          <StatusChip status={chipStatus} icon={icon} />
        </span>
      </Tooltip>
    );
  }
  return <StatusChip status={chipStatus} icon={icon} />;
};

export default ProvisioningStatusChip;
